import $ from 'jquery';
import { pickerCfg } from 'pickerCfg';
import contentTemplate from 'properties/style/table-header-text.ejs';
import BasePropertyView from 'BasePropertyView'
import themeService from 'ThemeService';
import undoService from 'UndoService';
import util from 'util/Util.js';
import textConstants from 'TextConstants.js';
import fontService from 'FontService';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class StyleTableHeaderTextView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'change #headerFontFamily, #customFontFamily, #headerFontSize': 'updateAttributes',
            'click #headerBoldText, #headerItalicText': 'updateTextStyleAttributes',
            'change #headerTextColor': 'updateColorAttributesWithValidation',
            'change #headerTextColorPicker': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        if (this.model.get('headerTextStyle') === 'italic !important') {
            this.model.set('headerItalicSelection', this.selectedColor, { silent: true });
        }

        if (this.model.get('headerTextWeight') === 'bold !important') {
            this.model.set('headerBoldSelection', this.selectedColor, { silent: true });
        }

        let currentFont = this.resolveThemeHeaderFontProperty('headerFontFamily');
        fontService.initCustomFont(this.model, currentFont);

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateColorAttributes(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.id.replace('Picker', '');
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);
        console.log('Old Value',oldValue);

        let color = this.resolveColor(propVal);
        // Update model
        this.model.set(propName, color);

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }

        // Update text input
        $('#' + propName).val(color);
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        // PF-3465 Undo/Redo for Header Color Picker.
        undoService.add({
            undo: () =>{
                // Update model
                this.model.set(propName, oldValue);

                let oldColor = this.resolveColor(oldValue);
                // Update text input
                $('#' + propName).val(oldColor);

            },
            redo:() => {
                // Update model
                this.model.set(propName, color);

                let newColor = this.resolveColor(propVal);

                // Update text input
                $('#' + propName).val(newColor);
            }
        },textConstants.UNDO_COLOR_HEADER_TEXT)
    }

    updateColorAttributesWithValidation(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        // PF-3465 Undo/Redo for Header Color Picker.
        undoService.add({
            undo: () =>{
                if (util.isValidColorcode(oldValue)) {
                    let color = this.resolveColor(oldValue);
                    this.model.set(propName, color);
                }
                this.render();

            },
            redo:() => {
                if (util.isValidColorcode(propVal)) {
                    let color = this.resolveColor(propVal);
                    this.model.set(propName, color);
                }
                this.render();
            }
        },textConstants.UNDO_COLOR_HEADER_TEXT);


        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color);
            if ( this.isThemeProperty(oldValue) ){
                themeService.deattachTheme(this);
            }
            return true;
        }

        // Call render if invalid color
        this.render();
        return false;
    }
    
    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        let weight = this.model.get('headerTextWeight');
        let style = this.model.get('headerTextStyle');

        let oldWeight = this.model.get('headerTextWeight');
        let oldStyle = this.model.get('headerTextStyle');

        if (propName === 'textWeight') {
            if (this.model.get('headerTextWeight') === 'bold') {
                this.model.set('headerBoldSelection', this.unselectedColor, { silent: true });
                weight = 'normal';
            } else {
                this.model.set('headerBoldSelection', this.selectedColor, { silent: true });
                weight = 'bold';
            }
        }

        if (propName === 'textStyle') {
            if (this.model.get('headerTextStyle') === 'italic') {
                this.model.set('headerItalicSelection', this.unselectedColor, { silent: true });
                style = 'normal';
            } else {
                this.model.set('headerItalicSelection', this.selectedColor, { silent: true });
                style = 'italic';
            }
        }

        this.model.set('headerTextWeight', weight, { silent: true });
        mobileSyncService.synchronize(this.model, {key: 'headerTextWeight', val: weight });
        this.model.set('headerTextStyle', style, { silent: true });
        mobileSyncService.synchronize(this.model, {key: 'headerTextStyle', val: style });
        this.model.trigger('change', this.model);
        if ( this.isThemeProperty(oldWeight) || this.isThemeProperty(oldStyle) ){
            themeService.deattachTheme(this);
        }
       

        // PF-3465 Undo/Redo for Header Style.
        undoService.add({
            undo: () =>{
                this.model.set('headerTextWeight', oldWeight, { silent: true });
                this.model.set('headerTextStyle', oldStyle, { silent: true });

                if (propName === 'textWeight') {
                    let propertyWeight= this.resolveAttributes(this.model.get('headerTextWeight'), 'textWeight');
                    if (propertyWeight === 'bold') {
                        this.model.set('headerBoldSelection', this.unselectedColor, { silent: true });
                    } else {
                        this.model.set('headerBoldSelection', this.selectedColor, { silent: true });
                    }
                }

                if (propName === 'textStyle') {
                    let propertyStyle= this.resolveAttributes(this.model.get('headerTextStyle'), 'textStyle');
                    if (propertyStyle === 'italic') {
                        this.model.set('headerItalicSelection', this.unselectedColor, { silent: true });
                    } else {
                        this.model.set('headerItalicSelection', this.selectedColor, { silent: true });
                    }
                }
                this.model.trigger('change', this.model);
            },
            redo:() => {
                this.model.set('headerTextWeight', weight, { silent: true });
                this.model.set('headerTextStyle', style, { silent: true });
                if (propName === 'textWeight') {
                    let propertyWeight= this.resolveAttributes(this.model.get('headerTextWeight'), 'textWeight');
                    if (propertyWeight === 'bold') {
                        this.model.set('headerBoldSelection', this.unselectedColor, { silent: true });
                    } else {
                        this.model.set('headerBoldSelection', this.selectedColor, { silent: true });
                    }
                }

                if (propName === 'textStyle') {
                    let propertyStyle= this.resolveAttributes(this.model.get('headerTextStyle'), 'textStyle');
                    if (propertyStyle === 'italic') {
                        this.model.set('headerItalicSelection', this.unselectedColor, { silent: true });
                    } else {
                        this.model.set('headerItalicSelection', this.selectedColor, { silent: true });
                    }
                }
                this.model.trigger('change', this.model);//
            }
        },textConstants.UNDO_HEADER_STYLE);
    }

    updateAttributes(ev, columnModel = undefined) {
        if (!ev) {
            return;
        }
        ev.preventDefault();

        let
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value,
            oldValue = this.model.get(propName),
            model = columnModel || this.model;
        let oldFontFamily = themeService.resolveThemeFont('fontFamily', model.get('titleFontFamily'));
        let oldTitleHeight = model.get('titleHeight');
        let oldPropVal=model.get(propName);
        let height=model.get('titleHeight');

        if( propName === 'titleFontSize' && model.get('factoryKey') === 'control_group' && model.get('titleText') !== '') {
            const fontFamily = themeService.resolveThemeFont('fontFamily', model.get('titleFontFamily'));
            height = util.measureTextHeight(model.get('titleText'), fontFamily + ',' + propVal + ',normal,normal', util.extractNum(model.get('width')));

            if (Number(height) > Number(model.get('titleHeight'))) {
                model.set('titleHeight', height, {silent: true});
            }

        } else if (columnModel && dropdownPropSet.has(propName)) {
            // We know it's a column because we have a columnModel.
            // So select table column bound control's font option, etc.
            util.selectDropdownItem( propName, propVal);
        }

        if(propName === "customFontFamily" || propName === "headerFontFamily"){
            propVal = fontService.updateCustomFont(model, propVal);
            propName = propName === 'customFontFamily' ? 'headerFontFamily' : propName === 'customTitleFontFamily' ? 'titleFontFamily' : propName;
        }
        
        model.set(propName, ev.currentTarget.value);
        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        undoService.add({
            undo: () =>{
                model.set('titleHeight',oldTitleHeight,{silent:true});
                model.set(propName, oldPropVal);
            },
            redo:() => {
                model.set('titleHeight',height,{silent:true});
                model.set(propName, propVal);
            }
        });
    }

    selectMask(value) {
        switch (value) {
            case 'bold': return this.selectedColor;
            case 'italic': return this.selectedColor;
            default: return this.unselectedColor;
        }
    }

    resolveAttributes(base, name) {
        let fontPropsArray = themeService.resolve(base).split(',');
        let result = 'normal !important';
        if (name === 'textWeight') {
            if (fontPropsArray[2]) {
                result = fontPropsArray[2].trim().toLowerCase();
            }
        } else {
            if (fontPropsArray[3]) {
                result = fontPropsArray[3].trim().toLowerCase();
            }
        }
        return result;
    }

    updateForm() {
        //set selected index to model value
        if (this.model.get('headerFontSize')) {
            $('#headerFontSize')
                .find(`option[value="${this.resolveThemeHeaderFontProperty('headerFontSize')}"]`)
                .attr(`selected`, true);
        }
        if (this.model.get('headerFontFamily')) {
            let titleFontFamily = this.resolveThemeHeaderFontProperty('headerFontFamily');
            const customFont = fontService.isCustomFont(titleFontFamily);
            titleFontFamily = !customFont ? titleFontFamily : "__custom__";

            $('#headerFontFamily')
                .find(`option[value="${titleFontFamily}"]`)
                .attr(`selected`, true);
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['headerTextColor']);

        if (this.isThemeProperty(props.headerTextWeight)) {
            props.headerTextWeight = this.resolveAttributes(props.headerTextWeight, 'textWeight');
            props.headerBoldSelection = this.selectMask(props.headerTextWeight);
        }
        if (this.isThemeProperty(props.headerTextStyle)) {
            props.headerTextStyle = this.resolveAttributes(props.headerTextStyle, 'textStyle');
            props.headerItalicSelection = this.selectMask(props.headerTextStyle);
        }

        this.$el.html(this.template(props));

        const fonts = fontService.loadFontsDropDown(true);
        $("#headerFontFamily").append(fonts);
        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.updateForm();
        this.delegateEvents();

        return this;
    }


}

export default StyleTableHeaderTextView;
